<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label text-primary">Tipos G:</label>
                </div>

                <div class="col-auto">
                    <select v-model="MoreFilters.TipoGarantia" @change="Lista" class="form-select">
                        <option value="">Seleccione una opcion</option>
                        <option v-for="(item,index) in TiposDeGarantias" :key="index" :value="item.Valor">{{ item.Texto }}</option>
                    </select>
                </div>

                <div class="col-auto">
                    <label class="col-form-label text-primary">Fecha S:</label>
                </div>

                <div class="col-auto">
                    <div class="input-group">
                        <div class="calendar">
                            <Datepicker v-model="MoreFilters.Fecha" @input="Lista" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker>
                        </div>
                         <div class="input-group-append">
                            <button  type="button" @click="BorrarFecha()" class="btn btn-outline-secondary text-danger mb-0" v-b-tooltip.hover.Top title="Borrar Fecha">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>

            </template>
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio</th>
                <th :class="StyleTh">Fecha Salida</th>
                <th :class="StyleTh">Nombre Cuenta</th>
                <th :class="StyleTh">Producto</th>
                <th :class="StyleTh">Tipo Garantia</th>
                <th :class="StyleTh">Fecha Solicitud</th>
                <th :class="StyleTh">Estatus</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><p :class="StyleTd">{{lista.Folio}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaSalida}}</p></td>
                    <td><p :class="StyleTd">{{lista.NombreCuenta}}</p></td>
                    <td><p :class="StyleTd">{{lista.Producto}}</p></td>
                    <td><p :class="StyleTd">{{lista.TipoGarantia}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaSolicitud}}</p></td>
                    <td>
                        <span v-if="lista.EstatusGarantia == 'Autorizada'" class="badge text-bg-success text-white">{{lista.EstatusGarantia}}</span>
                        <span v-else-if="lista.EstatusGarantia == 'Rechazada'" class="badge text-bg-danger text-white">{{lista.EstatusGarantia}}</span>
                        <span v-else class="badge text-bg-dark">{{lista.EstatusGarantia}}</span>
                    </td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="(lista.EstatusGarantia != 'Autorizada' && lista.EstatusGarantia != 'Rechazada')?true:false" :pShowBtnDelete="false" :pIsModal="true" :pId="GetDataGarantia(lista)" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity" :pHide="{Ocultar:(lista.EstatusGarantia != 'Autorizada' && lista.EstatusGarantia != 'Rechazada')?false:true,Accion:'Save'}">
							<template slot="btnaccion">

                                <button type="button" @click="VerPdf(lista.IdGarantiaS)" v-b-tooltip.hover.Top title="Ver Pdf" class="btn btn-link text-danger px-3 mb-0 mr-1">
                                    <i class="fas fa-file-pdf"></i> Pdf
                                </button>

                                <template v-if="segurity.Receive">
                                    <template v-if="lista.EstatusGarantia == 'Pendiente'">
                                        <button type="button" @click="CambiarEstatus(lista,'Rec')" v-b-tooltip.hover.Top title="Recepcionar Garantia" class="btn btn-link text-warning px-3 mb-0 mr-1">
                                            <i class="fas fa-box"></i> Recepcionar
                                        </button>
                                    </template>
                                </template>

                                <template v-if="segurity.Authorize">
                                    <template v-if="lista.EstatusGarantia == 'Recepcionada'">
                                        <button type="button" @click="RealizarDictamen(lista)" v-b-tooltip.hover.Top title="Autorizar Garantia" class="btn btn-link text-success px-3 mb-0 mr-1">
                                            <i class="fas fa-check-circle"></i> Autorizar
                                        </button>
                                    </template>
                                </template>

                                <template v-if="segurity.ViewDictamen">
                                    <template v-if="(lista.EstatusGarantia == 'Autorizada' || lista.EstatusGarantia == 'Rechazada')">
                                        <button type="button" @click="RealizarDictamen(lista)" v-b-tooltip.hover.Top title="Dictamen Garantia" class="btn btn-link text-info px-3 mb-0 mr-1">
                                            <i class="fas fa-address-book"></i> Dictamen
                                        </button>
                                    </template>
                                </template>

                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="20"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>
        
		<CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
			<template slot="Form">
				<FormDictamen :poBtnSave="oBtnSave2"></FormDictamen>
			</template>
		</CModal>
	</div>
</template>

<script>

import Calendar from '@/helpers/StaticComboBox.js';
import moment from 'moment';

import Form from '@/views/modulos/garantias/Form.vue';
import FormDictamen from '@/views/modulos/garantias/FormDictamen.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionGarantia';
const EmitEjecuta2 = 'seccionDictamen';

export default {
    name: 'ListaGarantia',
    props: ['sFiltros','pOrigen'],
    components: {
        Form,
        FormDictamen,
    },
    data() {
        return {
            ConfigList:{
                Title: 'Listado',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: false,
                TitleFirst: 'Garantias',
                BtnNewShow: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario",
                ModalNameId: 'ModalForm',
                ModalSize: 'xl',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            ConfigModal2:{
                ModalTitle: "Dictamen Garantia",
                ModalNameId: 'ModalForm2',
                ModalSize: 'md',
                EmitSeccion: EmitEjecuta2,
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                ShowBtnSave: true,
            },
            TiposDeGarantias:[
				{Valor:'Golpe-Rayadura',Texto:'Golpe/Rayadura'},
				{Valor:'Graduacion',Texto:'Graduación'},
				// {Valor:'Bisel',Texto:'Bisel'},
				{Valor:'Antiflex',Texto:'Antiflex'},
				{Valor:'Crizal',Texto:'Crizal'},
				{Valor:'Adaptacion',Texto:'Adaptación'},
				{Valor:'Otros',Texto:'Otros'},
			],
            MoreFilters: {
                TipoGarantia: '',
                Fecha: '',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Setpicker:Calendar.calendarSettings,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            let Fecha = '';
            if(this.MoreFilters.Fecha !=''){
                Fecha = moment(this.MoreFilters.Fecha).format('YYYY-MM-DD');
            }

            await this.$http.get("garantias",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    Fecha: Fecha,
                    TipoGarantia: this.MoreFilters.TipoGarantia
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('garantias/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        GetDataGarantia(item)
        {
            let obj = {
                IdGarantia: item.IdGarantiaS,
                Sitio: 'Garantias',
                ObjPedido: {
                    IdPedido: item.IdPedido
                },
                TipoVista: 2,
            };

            return obj;
        },
        CambiarEstatus(Item,Type)
        {
            this.$swal({
                title: '<h2 style="font-size:25px; font-weight: 700;">¿Desea '+(Type=='Rec')?'Recepcionar':'Autorizar'+' este registro?</h2>',
                text: 'Esta acción no se podra revertir ',
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: '#0096ED',
                cancelButtonColor: '#b92e27',
            }).then((result) =>
            {
                if(result.value)
                {
                    this.$http.get('garantiaschangestatus',{
                        params:{
                            IdGarantia: Item.IdGarantiaS,
                            Accion: Type,
                        }
                    }).then((res) => {
                        this.$swal({title:'Cambio Realizado',text:'',icon:'success',confirmButtonText: 'Aceptar',});
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        VerPdf()
        {},
        RealizarDictamen(item)
        {
            let TipoDictamen = 0;
            if(item.EstatusGarantia == 'Autorizada'){
                TipoDictamen = 1;
            }
            else if(item.EstatusGarantia == 'Rechazada'){
                TipoDictamen = 2;
            }

            if(TipoDictamen>0){
                this.oBtnSave2.ShowBtnSave = false;
            }
            else{
                this.oBtnSave2.ShowBtnSave = true;
            }

            let obj = {
                TipoDictamen: TipoDictamen,
                IdGarantia: item.IdGarantiaS,
                Dictamen: item.Dictamen,
            }

            this.bus.$emit('NewModal_'+EmitEjecuta2,obj);
        },
        BorrarFecha()
        {
            this.MoreFilters.Fecha = '';
            this.Lista();
        }
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
